export default function WhyCircleConnect() {
  const features = [
    {
      icon: "♻️",
      title: "ECO-FRIENDLY",
      description: "reducing reliance on paper through digital alternatives."
    },
    {
      icon: "📈",
      title: "EFFICIENCY",
      description: "simplifying communication and information exchange."
    },
    {
      icon: "💡",
      title: "INNOVATION",
      description: "strengthening brand image with modern, smart solutions"
    }
  ]

  return (
    <section id="why-circle-connect" className="section">
      <h2 className="why-title">Why Circle Connect?</h2>
      <div className="why-grid">
        {features.map((feature, index) => (
          <div key={index} className={`why-card`}>
            <div className="why-icon">{feature.icon}</div>
            <h3 className="why-heading">{feature.title}</h3>
            <p className="why-description">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

